export const liveMetrics = {
  episodesProcessed: 3842,
  sceneAnalysisAccuracy: 96.3,
  shortFormConversionRate: 94.7,
  avgProductionMinutes: 2.8,
  viewerGrowth: 12.4,
  clipsGenerated: 37,
};

export const detectedHighlights = [
  {
    id: "h1",
    timestamp: "38:14",
    duration: "0:47",
    confidence: 97,
    engagementSpike: 520,
    title: "종교 탈출 계기 첫 고백",
    thumbnail: "https://public.readdy.ai/ai/img_res/11c29a1d491223877bb865c46f602c88.jpg",
    status: "queued",
  },
  {
    id: "h2",
    timestamp: "14:22",
    duration: "1:03",
    confidence: 91,
    engagementSpike: 380,
    title: "예상 밖 반전 발언 순간",
    thumbnail: "https://readdy.ai/api/search-image?query=broadcast%20TV%20studio%20panel%20discussion%20intense%20moment%20anchor%20host%20reaction%20dark%20professional%20set%20modern&width=320&height=180&seq=hl002&orientation=landscape",
    status: "processing",
  },
  {
    id: "h3",
    timestamp: "07:55",
    duration: "0:32",
    confidence: 88,
    engagementSpike: 290,
    title: "핵심 논점 폭발 구간",
    thumbnail: "https://readdy.ai/api/search-image?query=TV%20news%20talk%20show%20host%20guest%20interview%20heated%20discussion%20dark%20modern%20studio%20professional%20broadcast&width=320&height=180&seq=hl003&orientation=landscape",
    status: "exported",
  },
  {
    id: "h4",
    timestamp: "52:08",
    duration: "0:58",
    confidence: 84,
    engagementSpike: 240,
    title: "눈물 터진 감동 장면",
    thumbnail: "https://readdy.ai/api/search-image?query=Korean%20TV%20show%20emotional%20moment%20interview%20documentary%20style%20dark%20background%20soft%20lighting%20close%20up%20face&width=320&height=180&seq=hl004&orientation=landscape",
    status: "queued",
  },
];

export const performanceStats = [
  { label: "처리된 에피소드", value: "3,842", change: "+18.3%", up: true },
  { label: "평균 숏폼 전환율", value: "94.7%", change: "+4.2%", up: true },
  { label: "배포 성공률", value: "99.2%", change: "+0.4%", up: true },
  { label: "절약된 편집 시간(h)", value: "28,400", change: "+22.1%", up: true },
];

export const distributionPlatforms = [
  { name: "TikTok", icon: "ri-tiktok-fill", clips: 847, reach: "12.4M", color: "#10B981" },
  { name: "YouTube Shorts", icon: "ri-youtube-fill", clips: 631, reach: "9.8M", color: "#F59E0B" },
  { name: "Instagram Reels", icon: "ri-instagram-fill", clips: 512, reach: "7.2M", color: "#00D9FF" },
];

export const contentLibrary = [
  {
    id: "c1",
    title: "종교 탈출 고백 – 핵심 발언 모음",
    duration: "0:47",
    platform: "YouTube Shorts",
    views: "4.2M",
    engagement: "9.1%",
    date: "2026-03-18",
    thumbnail: "https://readdy.ai/api/search-image?query=cable%20TV%20interview%20studio%20close%20up%20emotional%20moment%20confession%20dark%20cinematic%20professional%20broadcast%20Korean&width=400&height=225&seq=cl001&orientation=landscape",
    status: "published",
  },
  {
    id: "c2",
    title: "국보급 반전 발언 – 앵커 반응",
    duration: "0:58",
    platform: "TikTok",
    views: "2.8M",
    engagement: "11.4%",
    date: "2026-03-17",
    thumbnail: "https://readdy.ai/api/search-image?query=Korean%20cable%20TV%20anchor%20host%20shocked%20reaction%20moment%20news%20program%20dark%20studio%20modern%20set%20broadcast&width=400&height=225&seq=cl002&orientation=landscape",
    status: "published",
  },
  {
    id: "c3",
    title: "시사 인터뷰 – 논점 폭발 구간",
    duration: "1:12",
    platform: "Instagram Reels",
    views: "1.9M",
    engagement: "7.8%",
    date: "2026-03-16",
    thumbnail: "https://readdy.ai/api/search-image?query=Korean%20TV%20talk%20show%20debate%20panel%20discussion%20modern%20dark%20studio%20professional%20broadcast%20cinematic&width=400&height=225&seq=cl003&orientation=landscape",
    status: "published",
  },
  {
    id: "c4",
    title: "예능 최고 명장면 – 스튜디오 폭소",
    duration: "1:07",
    platform: "TikTok",
    views: "3.1M",
    engagement: "13.2%",
    date: "2026-03-15",
    thumbnail: "https://readdy.ai/api/search-image?query=Korean%20variety%20show%20entertainment%20studio%20audience%20laughing%20dark%20colorful%20stage%20set%20broadcast&width=400&height=225&seq=cl004&orientation=landscape",
    status: "published",
  },
  {
    id: "c5",
    title: "다큐 핵심 장면 – 밀착 고백",
    duration: "0:45",
    platform: "YouTube Shorts",
    views: "987K",
    engagement: "6.3%",
    date: "2026-03-14",
    thumbnail: "https://readdy.ai/api/search-image?query=documentary%20style%20close%20up%20interview%20subject%20emotional%20raw%20authentic%20dark%20cinematic%20professional%20camera&width=400&height=225&seq=cl005&orientation=landscape",
    status: "archived",
  },
  {
    id: "c6",
    title: "연예 뉴스 – 충격 발언 순간",
    duration: "0:38",
    platform: "Instagram Reels",
    views: "2.4M",
    engagement: "10.7%",
    date: "2026-03-13",
    thumbnail: "https://readdy.ai/api/search-image?query=entertainment%20news%20show%20studio%20modern%20Korean%20broadcast%20anchor%20desk%20dramatic%20reveal%20dark%20professional%20lighting&width=400&height=225&seq=cl006&orientation=landscape",
    status: "published",
  },
];

export const engagementTimeline = [
  { time: "0분", viewers: 8200, engagement: 38, highlights: 0 },
  { time: "10분", viewers: 14700, engagement: 45, highlights: 0 },
  { time: "20분", viewers: 22400, engagement: 54, highlights: 1 },
  { time: "30분", viewers: 35800, engagement: 68, highlights: 2 },
  { time: "40분", viewers: 62100, engagement: 88, highlights: 1 },
  { time: "50분", viewers: 89400, engagement: 96, highlights: 3 },
  { time: "60분", viewers: 124000, engagement: 94, highlights: 2 },
  { time: "70분", viewers: 118200, engagement: 91, highlights: 1 },
  { time: "80분", viewers: 136000, engagement: 98, highlights: 4 },
];

export const clients = [
  { name: "tvN", category: "케이블 엔터테인먼트", clips: "8,400+", views: "620M+" },
  { name: "JTBC", category: "종합편성채널", clips: "6,200+", views: "480M+" },
  { name: "MBC", category: "지상파 방송", clips: "5,800+", views: "410M+" },
  { name: "KBS Media", category: "공영방송 디지털", clips: "3,100+", views: "230M+" },
];
